export function getConfig() {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER"
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience =
    process.env.REACT_APP_AUTH0_AUDIENCE &&
    process.env.REACT_APP_AUTH0_AUDIENCE !== "YOUR_API_IDENTIFIER"
      ? process.env.REACT_APP_AUTH0_AUDIENCE.replace("\r", "")
      : null
  return {
    domain: process.env.REACT_APP_AUTH0_DOMAIN.replace("\r", ""),
    clientId: process.env.REACT_APP_AUTH0_CLIENTID.replace("\r", ""),
    ...(audience ? { audience } : null),
  }
}
